import { render, staticRenderFns } from "./customConfirmAction.vue?vue&type=template&id=16b6d918"
import script from "./customConfirmAction.vue?vue&type=script&lang=js"
export * from "./customConfirmAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports